/* eslint-disable camelcase,no-continue */
import {NotixApi} from "Services/api";
import { ACTIVE_USERS_KEY, SENDING_COUNT_KEY } from "./user";

function responseST(sending) {
  const localSendingCount = localStorage.getItem(SENDING_COUNT_KEY);

  if (sending.count === 0) {
    if (localSendingCount > 0) {
      return { count: localSendingCount };
    } else {
      return { count: sending.count };
    }
  } else {
    localStorage.setItem(SENDING_COUNT_KEY, sending.count);
    return { count: sending.count };
  }
}

const responseActiveUsersZone = (zones) => {
  const localActiveUsers = JSON.parse(localStorage.getItem(ACTIVE_USERS_KEY));

  const preActiveUsersZone = zones.reduce((map, obj) => {
    map[obj.id] = obj.count;
    return map;
  }, {});

  Object.keys(preActiveUsersZone).forEach((zoneID) => {
    if (preActiveUsersZone[zoneID] === 0) {
      if (localActiveUsers?.[zoneID] > 0) {
        preActiveUsersZone[zoneID] = localActiveUsers[zoneID];
      }
    }
  });

  localStorage.setItem(ACTIVE_USERS_KEY, JSON.stringify(preActiveUsersZone));

  return preActiveUsersZone;
};

function numbFormat(options) {
  const number = Math.abs(Number(options.number));

  // Nine zeros for Billions
  if (Number(number) >= 1.0e9) {
    return `${(number / 1.0e9).toFixed(options.billion.decimal)} ${
      options.billion.unit
    }`;
  }

  // Six zeros for Millions
  if (Number(number) >= 1.0e6) {
    return `${(number / 1.0e6).toFixed(options.million.decimal)} ${
      options.million.unit
    }`;
  }

  // Thrhee zeros for Thousands
  if (Number(number) >= 1.0e3) {
    return `${(number / 1.0e3).toFixed(options.thousand.decimal)} ${
      options.thousand.unit
    }`;
  }

  return number;
}

export function formatCount(value) {
  return numbFormat({
    number: value,
    billion: {
      decimal: 1,
      unit: "B",
    },
    million: {
      decimal: 1,
      unit: "M",
    },
    thousand: {
      decimal: 1,
      unit: "K",
    },
  });
}

class Counters {
  getSendingTotal() {
    return NotixApi.get(`/counter/sending-total`).then((result) => {
      return responseST(result);
    });
  }

  getActiveUsersZones() {
    return NotixApi.get(`/counter/active-users-zones`).then((result) => {
      return responseActiveUsersZone(result);
    });
  }
}

const countersInstance = new Counters();

export default countersInstance;